import { TwoStepEnhancedLoginForm } from './TwoStepEnhancedLoginForm';
import {
  UserAction,
  NestedHome,
  NestedProject,
  NestedSearch,
} from '@habity/types';

interface EnhancedLoginFormProps {
  authHome: NestedHome | null;
  authProject: NestedProject | null;
  authAction: UserAction | null;
  // redirectTo is not used in this component but kept for API compatibility
  redirectTo?: string;
  /** Search filters for created_search_profile action */
  searchFilters?: Partial<NestedSearch>;
}

export const EnhancedLoginForm = ({
  authHome,
  authProject,
  authAction,
  redirectTo,
  searchFilters,
}: EnhancedLoginFormProps) => {
  return (
    <TwoStepEnhancedLoginForm
      authHome={authHome}
      authProject={authProject}
      authAction={authAction}
      redirectTo={redirectTo}
      searchFilters={searchFilters}
      showBackButton={true}
    />
  );
};
